<template>
  <div class="mt-48 bg-white bg-opacity-60 min-h-screen text-center">
    <div class="flex items-center justify-start bg-beige-academy-300 w-full py-5
      text-white text-left">
      <div class="text-base lg:text-lg w-full px-10 lg:px-20 font-sans-serif font-bold flex">
        <router-link class="pr-1" to="/teacher-dashboard/classrooms">
          {{ $t('classrooms.classrooms') }}
        </router-link> /
        <router-link class="px-1" to="/teacher-dashboard/templates">
          {{ $t('template.templates') }}
        </router-link>
        <span> / {{ $t('template.new') }} </span>
      </div>
    </div>
    <div class="flex w-full justify-center items-center mt-10 px-10 lg:px-64 text-black">
      <h1 class="text-lg lg:text-2xl text-center w-full uppercase">
        {{ $t('template.newTemplate') }}</h1>
    </div>
    <div class="flex flex-col mx-auto px-10 lg:px-64 mt-20 text-black justify-center">
      <div class="flex flex-col md:flex-row py-6 items-center justify-center">
        <label for="lesson-type" class="uppercase font-sans-serif md:w-1/4 mb-3 md:mb-0
        text-left text-base lg:text-xl">
          {{ $t('template.description') }}:
        </label>
        <input type="text" id="lesson-type" class="border border-grey-academy-150 text-lg
        bg-beige-academy-200 outline-none w-full lg:w-3/4 py-3 pl-4 rounded-lg shadow-lg
        font-sans-serif"
        v-model="template.description">
      </div>
    </div>

    <button class="uppercase bg-orange-academy-300 text-white px-4 py-2 rounded-lg font-bold
      font-sans-serif z-20 text-lg mt-10" @click="saveTemplate">
      {{ $t('template.save') }}
    </button>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      template: {
        description: '',
      },

      availableMedia: [],
      selectedMedia: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  methods: {
    saveTemplate() {
      axios.post(`/api/teachers/${this.user.teacher.id}/classroom-templates`, this.template).then(({ data }) => {
        this.$router.push(`/teacher-dashboard/templates/${data.id}`);
      });
    },
  },
};
</script>
